import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MemberService } from '../../../core/members/member.service';
import { Angulartics2 } from 'angulartics2';
import { filter, first } from 'rxjs/operators';
import { LoadMember } from '@app/core/store/member/member-actions';
import { Store } from '@ngrx/store';
import * as fromRoot from '@app/core/store/reducers';
import { CookieConsentService, COOKIES_CONSENT_KEY } from '@app/core/cookie-consent/cookie-consent.service';
import { transformProfileErrors } from '@app/+profile-form/views/profile-errors-helpers';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { ProfileFormComponent } from '@app/+profile-form/components/profile-form/profile-form.component';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { UPDATE_CONFIRMATION_PATH } from '@app/+profile-form/profile-routes';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TopNavbarComponent,
    TranslatePipe,
    RouterLink,
    LoyaltyClubHeaderComponent,
    ProfileFormComponent,
    LoyaltyClubFooterComponent,
  ],
})
export class EditProfileComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private memberService = inject(MemberService);
  private analytics = inject(Angulartics2);
  private store = inject<Store<fromRoot.State>>(Store);
  private cookieConsentService = inject(CookieConsentService);


  public memberData: any;
  public formErrors: any = {};

  public ngOnInit(): void {
    this.loadMember();
  }

  public onSave(form: any): void {
    this.memberService.update(form).subscribe(
      (json) => this.onSuccessSave(json),
      (response) => this.onErrorSave(response.error.errors),
    );
  }

  private loadMember(): void {
    this.memberService.get().pipe(
      filter((member) => !!member),
      first(),
    ).subscribe((member) => {
      this.memberData = {
        properties: member.properties,
        consents: member.consents,
      };
    });
  }

  private onSuccessSave(json: { consents: Record<string, { status: boolean }> }): void {
    this.cookieConsentService.toggle(!!json.consents[COOKIES_CONSENT_KEY]?.status, false);

    this.analytics.eventTrack.next({
      action: 'update',
      properties: { category: 'member_change', label: 'Succesfull member change' },
    });
    this.store.dispatch(new LoadMember(true));
    this.router.navigate(['..', UPDATE_CONFIRMATION_PATH], { relativeTo: this.route, replaceUrl: true });
  }

  private onErrorSave(errors: any): void {
    this.formErrors = transformProfileErrors(errors);
  }

}
